<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>实验管理</el-breadcrumb-item>
      <el-breadcrumb-item>实验列表</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="panel">
      <el-page-header
        @back="$router.go(-1)"
        :content="model.id ? '编辑实验' : '添加实验'"
      ></el-page-header>
      <el-form :model="model">
        <div class="form-horizontal">
          <div class="">
            <div class="row">
              <div class="col-sm-5">
                <div class="form-group col-sm-12">
                  <div class="col-sm-8">
                    <label class="col-md-12 dl-title">基本信息</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-md-4 control-label">实验人</label>
                      <div class="col-md-8">
                        <el-input
                          v-model="model.experimenter"
                          placeholder="实验人"
                        ></el-input>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-md-4 control-label">实验日期</label>
                      <div class="col-md-8">
                        <el-date-picker
                          style="width: 100%"
                          v-model="model.day"
                          type="date"
                          size="small"
                          placeholder="选择日期时间"
                          value-format="yyyy-MM-dd"
                        >
                        </el-date-picker>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-md-4 control-label">单号</label>
                      <div class="col-md-8">
                        <el-input
                          v-model="model.order_number"
                          placeholder="单号"
                          size="small"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-md-4 control-label">实验原因</label>
                      <div class="col-md-8">
                        <el-input
                          v-model="model.reason"
                          placeholder="实验原因"
                          size="small"
                          type="textarea"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group col-sm-12">
                  <div class="col-sm-8">
                    <label class="col-md-12 dl-title">设计数据</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-md-4 control-label">钻具类型</label>
                      <div class="col-md-8">
                        <el-input
                          v-model="model.drill_tool_category"
                          placeholder="钻具类型"
                          size="small"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-md-4 control-label">转子头数</label>
                      <div class="col-md-8">
                        <el-input
                          v-model.number="model.rotor_head_number"
                          placeholder="转子头数"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-md-4 control-label">定子头数</label>
                      <div class="col-md-8">
                        <el-input
                          v-model.number="model.stator_head_number"
                          placeholder="定子头数"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-md-4 control-label">定子尺寸(mm)</label>
                      <div class="col-md-8">
                        <el-input
                          v-model.number="model.stator_size"
                          placeholder="定子尺寸"
                          onkeyup="this.value=this.value.replace(/[^0-9\.]/g,'')"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-md-4 control-label">定子长度(mm)</label>
                      <div class="col-md-8">
                        <el-input
                          v-model.number="model.stator_length"
                          placeholder="定子长度"
                          onkeyup="this.value=this.value.replace(/[^0-9\.]/g,'')"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-md-4 control-label">过盈范围</label>
                      <div class="col-md-8">
                        <el-input
                          v-model="model.interference_range"
                          placeholder="过盈范围"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-md-4 control-label">转子尺寸(mm)</label>
                      <div class="col-md-8">
                        <el-input
                          v-model.number="model.rotor_size"
                          placeholder="转子尺寸"
                          onkeyup="this.value=this.value.replace(/[^0-9\.]/g,'')"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-md-4 control-label">转子长度(mm)</label>
                      <div class="col-md-8">
                        <el-input
                          v-model.number="model.rotor_length"
                          placeholder="转子长度"
                          onkeyup="this.value=this.value.replace(/[^0-9\.]/g,'')"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-md-4 control-label">橡胶类型</label>
                      <div class="col-md-8">
                        <el-input
                          v-model="model.rubber_category"
                          placeholder="橡胶类型"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group col-sm-12">
                  <div class="col-sm-8">
                    <label class="col-md-12 dl-title">实测数据</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-md-4 control-label">整机钢号</label>
                      <div class="col-md-8">
                        <el-input
                          v-model="model.actual_steel_number"
                          placeholder="整机钢号"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-md-4 control-label">芯轴编号</label>
                      <div class="col-md-8">
                        <el-input
                          v-model="model.actual_mandrel_number"
                          placeholder="芯轴编号"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-md-4 control-label">橡胶类型</label>
                      <div class="col-md-8">
                        <el-input
                          v-model="model.actual_rubber_category"
                          placeholder="橡胶类型"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                  <!-- </div> -->
                  <!-- <div class="row"> -->
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-md-4 control-label">定子尺寸(mm)</label>
                      <div class="col-md-8">
                        <el-input
                          v-model.number="model.actual_stator_size"
                          placeholder="定子尺寸"
                          onkeyup="this.value=this.value.replace(/[^0-9\.]/g,'')"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-md-4 control-label">定子长度(mm)</label>
                      <div class="col-md-8">
                        <el-input
                          v-model.number="model.actual_stator_length"
                          placeholder="定子长度"
                          onkeyup="this.value=this.value.replace(/[^0-9\.]/g,'')"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-md-4 control-label">定子钢号</label>
                      <div class="col-md-8">
                        <el-input
                          v-model="model.actual_stator_steel_number"
                          placeholder="定子钢号"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                  <!-- </div> -->
                  <!-- <div class="row"> -->
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-md-4 control-label">转子尺寸(mm)</label>
                      <div class="col-md-8">
                        <el-input
                          v-model.number="model.actual_rotor_size"
                          placeholder="转子尺寸"
                          onkeyup="this.value=this.value.replace(/[^0-9\.]/g,'')"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-md-4 control-label">转子长度(mm)</label>
                      <div class="col-md-8">
                        <el-input
                          v-model.number="model.actual_rotor_length"
                          placeholder="转子长度"
                          onkeyup="this.value=this.value.replace(/[^0-9\.]/g,'')"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-md-4 control-label">转子钢号</label>
                      <div class="col-md-8">
                        <el-input
                          v-model="model.actual_rotor_steel_number"
                          placeholder="转子钢号"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                  <!-- </div> -->
                  <!-- <div class="row"> -->
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-md-4 control-label">过盈量(mm)</label>
                      <div class="col-md-8">
                        <el-input
                          v-model.number="model.actual_interference"
                          placeholder="过盈量"
                          onkeyup="this.value=this.value.replace(/[^0-9\.]/g,'')"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-md-4 control-label">镀层类型</label>
                      <div class="col-md-8">
                        <el-input
                          v-model="model.actual_plating_category"
                          placeholder="镀层类型"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-md-4 control-label">镀层厚度(mm)</label>
                      <div class="col-md-8">
                        <el-input
                          v-model.number="model.actual_plating_thickness"
                          placeholder="镀层厚度"
                          onkeyup="this.value=this.value.replace(/[^0-9\.]/g,'')"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mt-10">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-md-4 control-label"
                        >实验结果及处理意见</label
                      >
                      <div class="col-md-8">
                        <el-input
                          v-model="model.remark"
                          type="textarea"
                          placeholder="实验结果及处理意见"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-7">
                <div class="form-group col-sm-12 mar-no flex">
                  <div class="col-sm-2">
                    <label class="col-md-12 dl-title m-t-0 m-b-0 pad-no"
                      >测量数据</label
                    >
                  </div>
                  <div class="col-sm-5">
                    <div class="form-group mar-no">
                      <label class="col-md-4 control-label text-info"
                        >流量单位</label
                      >
                      <div class="col-md-8">
                        <el-select v-model="model.flow_unit">
                          <el-option
                            :key="1"
                            :value="1"
                            label="加仑 / 分钟(gpm)"
                          ></el-option>
                          <el-option
                            :key="2"
                            :value="2"
                            label="升/分钟(lpm)"
                          ></el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-5">
                    <div class="form-group mar-no">
                      <label class="col-md-4 control-label text-info"
                        >扭矩单位</label
                      >
                      <div class="col-md-8">
                        <el-select v-model="model.torque_unit">
                          <el-option
                            :key="1"
                            :value="1"
                            label="英尺*磅力(ft*lbf)"
                          ></el-option>
                          <el-option
                            :key="2"
                            :value="2"
                            label="牛米(Nm)"
                          ></el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="bord-all col-sm-12">
                  <div
                    v-for="(measuring, index) in model.measurings"
                    :key="index"
                  >
                    <div class="form-group col-sm-12 mar-no">
                      <div class="col-sm-6">
                        <label class="col-md-12 dl-title" v-if="index == 0"
                          >启动</label
                        >
                        <label class="col-md-12 dl-title" v-else-if="index == 1"
                          >扭矩增加</label
                        >
                        <label
                          class="col-md-12 dl-title"
                          v-else-if="index == model.measurings.length - 1"
                          >结束</label
                        >
                      </div>
                    </div>
                    <div class="col-sm-12 experiment-parent">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label class="col-md-4 control-label"
                            >转速(rpm)</label
                          >
                          <div class="col-md-8">
                            <el-input
                              v-model.number="measuring.rotating_speed"
                              @change="sumEfficienct(measuring)"
                              placeholder="转速"
                              onkeyup="this.value=this.value.replace(/[^0-9\.]/g,'')"
                            ></el-input>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label class="col-md-4 control-label flow-unit"
                            >流量({{ flowUnitOptions[model.flow_unit] }})</label
                          >
                          <div class="col-md-8">
                            <el-input
                              v-model.number="measuring.flow"
                              @change="sumEfficienct(measuring)"
                              placeholder="流量"
                              onkeyup="this.value=this.value.replace(/[^0-9\.]/g,'')"
                            ></el-input>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label class="col-md-4 control-label torque-unit"
                            >扭矩({{
                              torqueUnitOptions[model.torque_unit]
                            }})</label
                          >
                          <div class="col-md-8">
                            <el-input
                              v-model.number="measuring.torque"
                              @change="sumEfficienct(measuring)"
                              placeholder="扭矩"
                              onkeyup="this.value=this.value.replace(/[^0-9\.]/g,'')"
                            ></el-input>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label class="col-md-4 control-label"
                            >压力(MPa)</label
                          >
                          <div class="col-md-8">
                            <el-input
                              v-model.number="measuring.pressure"
                              @change="sumEfficienct(measuring)"
                              placeholder="压力"
                              onkeyup="this.value=this.value.replace(/[^0-9\.]/g,'')"
                            ></el-input>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label class="col-md-4 control-label"
                            >效率(100%)</label
                          >
                          <div class="col-md-8">
                            <el-input
                              v-model.number="measuring.efficiency"
                              placeholder="效率"
                            ></el-input>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-sm-12"
                      v-if="index == model.measurings.length - 2"
                    >
                      <div class="col-sm-4">
                        <div class="col-md-4">
                          <el-button
                            type="primary"
                            size="mini"
                            @click="
                              model.measurings.splice(
                                model.measurings.length - 1,
                                0,
                                newMeasuring
                              )
                            "
                            >添加</el-button
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="panel-footer">
            <div class="row">
              <div class="col-lg-4 col-md-6">
                <div class="col-md-8 col-md-offset-4">
                  <el-button type="primary" @click="handlePost">保存</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  experimentNew,
  experimentUpdate,
  experimentDetail,
} from '@/service/getData'

export default {
  data() {
    return {
      model: {
        experimenter: '',
        day: '',
        order_number: '',
        reason: '',
        drill_tool_category: '',
        rotor_head_number: '',
        stator_head_number: '',
        stator_size: '',
        stator_length: '',
        interference_range: '',
        rotor_size: '',
        rotor_length: '',
        rubber_category: '',
        actual_steel_number: '',
        actual_mandrel_number: '',
        actual_rubber_category: '',
        actual_stator_size: '',
        actual_stator_length: '',
        actual_stator_steel_number: '',
        actual_rotor_size: '',
        actual_rotor_length: '',
        actual_rotor_steel_number: '',
        actual_interference: '',
        actual_plating_category: '',
        actual_plating_thickness: '',
        remark: '',
        flow_unit: 1,
        torque_unit: 1,
        measurings: [
          {
            category: 1,
            rotating_speed: 0,
            flow: 0,
            torque: 0,
            pressure: 0,
            efficiency: 0,
          },
          {
            category: 2,
            rotating_speed: 0,
            flow: 0,
            torque: 0,
            pressure: 0,
            efficiency: 0,
          },
          {
            category: 3,
            rotating_speed: 0,
            flow: 0,
            torque: 0,
            pressure: 0,
            efficiency: 0,
          },
        ],
      },
      newMeasuring: {
        category: 2,
        rotating_speed: 0,
        flow: 0,
        torque: 0,
        pressure: 0,
        efficiency: 0,
      },
      flowUnitOptions: {
        1: 'gpm',
        2: 'lpm',
      },
      torqueUnitOptions: {
        1: 'ft*lbf',
        2: 'Nm',
      },
    }
  },
  watch: {
    'model.flow_unit': 'resumAllEfficiency',
    'model.torque_unit': 'resumAllEfficiency',
  },
  created() {
    if (this.$route.params.id) {
      this.getModel(this.$route.params.id)
    }
  },
  methods: {
    async handlePost() {
      if (this.model.id) {
        let res = await experimentUpdate(this.model)
        if (res.code == 0) {
          this.$router.go(-1)
        }
      } else {
        let res = await experimentNew(this.model)
        if (res.code == 0) {
          this.$router.go(-1)
        }
      }
    },

    resumAllEfficiency() {
      this.model.measurings.map((item) => {
        this.sumEfficienct(item)
      })
    },

    async getModel(id) {
      let res = await experimentDetail(id)
      if (
        res.data.measurings.filter((item) => item.category == 1).length == 0
      ) {
        let measuring = this.clone(this.newMeasuring)
        measuring.category = 1
        res.data.measurings.splice(0, 0, measuring)
      }

      if (
        res.data.measurings.filter((item) => item.category == 2).length == 0
      ) {
        let measuring = this.clone(this.newMeasuring)
        res.data.measurings.splice(1, 0, measuring)
      }

      if (
        res.data.measurings.filter((item) => item.category == 3).length == 0
      ) {
        let measuring = this.clone(this.newMeasuring)
        measuring.category = 3
        res.data.measurings.splice(res.data.measurings.length - 1, 0, measuring)
      }

      this.model = res.data
    },

    sumEfficienct(item) {
      let rotating_speed = item.rotating_speed
      let flow = item.flow
      let torque = item.torque
      let pressure = item.pressure
      let out_efficient = 0
      let in_efficient = 0

      if (rotating_speed > 0 && flow > 0 && torque > 0 && pressure > 0) {
        if (this.model.torque_unit == 1) {
          out_efficient = (torque * 1.3558 * rotating_speed) / 9550
        } else {
          out_efficient = (torque * rotating_speed) / 9550
        }

        if (this.model.flow_unit == 1) {
          in_efficient = (flow * 3.7854 * pressure) / 60
        } else {
          in_efficient = (flow * pressure) / 60
        }
        var efficiency = (out_efficient / in_efficient) * 100
        efficiency = parseInt(Math.round(efficiency * 100)) / 100
        item.efficiency = efficiency
      } else {
        item.efficiency = 0
      }
    },
  },
}
</script>

<style scoped>
.form-horizontal .control-label {
  height: 33px;
  padding-top: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 0;
  white-space: normal;
  overflow: visible;
}
</style>